import FormContainer from '../../components/form/FormContainer';
import CheckoutSteps from '../../components/checkout/CheckoutSteps';
import ShippingAddressManager from '../../components/checkout/ShippingAddressManager';
import Meta from '../../components/layout/Meta';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { groupOrderItems } from '../../utils/cartUtils';

const ShippingScreen = () => {
    const navigate = useNavigate();
    const { activeOrder, selectedCompanyRuc } = useSelector((state) => state.cart);
    const { companiesByRuc } = useSelector((state) => state.companies);

    // Keep grouping logic in sync with PlaceOrderScreen to resolve company IDs to full company objects.
    const groupedItems = useMemo(() => {
        return groupOrderItems(activeOrder, companiesByRuc);
    }, [activeOrder, companiesByRuc]);

    const cartItems = Object.values(groupedItems).flatMap((g) => g.orderItems || g.items || []);

    useEffect(() => {
        if (cartItems.length === 0) {
            navigate('/cart');
        } else if (!selectedCompanyRuc) {
            navigate('/cart');
        }
    }, [cartItems.length, selectedCompanyRuc, navigate]);

    return (
        <>
            <Meta title="Dirección de Entrega" />
            <FormContainer>
                <CheckoutSteps shippingScreen />
            </FormContainer>
            <div className="shipping-header text-center my-4">
                <h1 className="fw-bold">Dirección de Entrega</h1>
                {selectedCompanyRuc && groupedItems[selectedCompanyRuc] && (
                    <div className="d-flex flex-column align-items-center justify-content-center mb-2">
                        <div className="d-flex align-items-center justify-content-center gap-3">
                            {groupedItems[selectedCompanyRuc].companyInfo?.logoUrl && (
                                <img
                                    src={groupedItems[selectedCompanyRuc].companyInfo.logoUrl}
                                    alt={groupedItems[selectedCompanyRuc].companyInfo.tradeName || groupedItems[selectedCompanyRuc].companyInfo.name || 'Empresa'}
                                    style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                                />
                            )}
                            <h5 className="text-muted mb-0">
                                Pago correspondiente a <span className="text-primary fw-bold">{groupedItems[selectedCompanyRuc].companyInfo?.tradeName || groupedItems[selectedCompanyRuc].companyInfo?.name || groupedItems[selectedCompanyRuc].name || 'Comercial Santy'}</span>
                            </h5>
                        </div>
                    </div>
                )}
                <p className="text-muted mt-2">Selecciona dónde quieres recibir tu pedido o recógelo en nuestro local</p>
            </div>
            <ShippingAddressManager />
        </>
    );
};

export default ShippingScreen;
